// extracted by mini-css-extract-plugin
export var orderDetails = "_k9-2";
export var orderImage = "_k9-1";
export var orderMeta = "_k9-3";
export var orderSummary = "_k9-0";
export var rightArrow = "_k9-4";